<template>
  <div>
    <vs-sidebar
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isSidebarActiveLocal"
    >
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{setting.id ? 'EDITAR RESPOSTA RÁPIDA' :'CRIAR RESPOSTA RÁPIDA' }}</h4>
        <feather-icon
          icon="XIcon"
          @click.stop="isSidebarActiveLocal = false"
          class="cursor-pointer"
        />
      </div>
      <vs-divider class="mb-0" />

      <VuePerfectScrollbar
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="p-6">        

          <div class="mt-5">
            <p style="font-size:13px;" class="ml-1 mb-1">Identificador</p>
              <vs-input name="identifier" 
                v-model="setting.identifier" 
                v-validate="'required'" 
                :maxlength="maxLength"
                @input="preventCharacters"
                @keydown="preventCharacters"
                @paste="preventCharacters"
              />
            <span class="text-danger text-sm" v-show="errors.has('identifier')" >{{ errors.first('value') }}</span>
            <p v-if="setting.identifier.length >= maxLength" class="text-danger mt-2 text-xs">Limite máximo de 80 caracteres excedido</p>
          </div>

          <h4 class="ml-1 mt-4"  v-if="setting.identifier.length > 0" style="word-break: break-all;">
            {{ snakeCase(setting.identifier)}}
          </h4>

          <div class="mt-6">
            <p style="font-size:13px;" class="ml-1">Texto Resposta Rápida</p>
            <textarea
              class="vs-textarea text-area message-text-area"
              name="value"
              placeholder="Mensagem"
              v-model="setting.value"
              v-validate="'required'"
              style="border: 1px"
              ref="quick-answer"
              id="wa-message"
              rows="10"
            />
            <span class="text-danger text-sm" v-show="errors.has('value')">{{ errors.first('value') }}</span>
          </div>

          <div data-testid="name-variable-quick-answer-div">
            <vs-button 
              class="mt-4" 
              type="border" 
              @click="insertTagOnText"
              data-testid="name-variable-quick-answer-btn"
            >
              + Adicionar nome
            </vs-button>

          </div>

          <div style="font-size: 14px;" class="mr-4">
            <div>
              <div class="message-preview" style="float: right; margin-top:3em; word-break: break-all;" v-if="setting.value.length !== 0">
                  <p class="message">{{setting.value}}</p>
              </div>
            </div>
        </div>

      </div>
      </VuePerfectScrollbar>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="submitData" :disabled="setting.value && setting.identifier ? false : true">
          Salvar
        </vs-button>
        <vs-button
          type="border"
          color="danger"
          @click="isSidebarActiveLocal = false"
        >
          Cancelar
        </vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import request from '@/http/requests/messageTemplate'

export default {
  name: 'settings-view-sidebar',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    setting: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      maxLength: 81,
      exceededMaxLength: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      clearData: true,
      forbiddenCharacters: ['/']
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        this.errors.clear()
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.errors.clear()
          this.$emit('closeSidebar')
        }
      }
    },
  },
  methods: {
    preventCharacters(event) {
      if (this.forbiddenCharacters.includes(event.key)) {
        event.preventDefault();
      }
      setTimeout(() => this.setting.identifier = this.setting.identifier.replaceAll('/', ''), 700);
    },
    snakeCase(str) {
      return str && str.match(/(?:[A-Z]{2,}|[A-ZÀ-Ú]?[a-zà-úŕ]+)[0-9]*(?:(?<![A-Za-zÀ-Úà-ú])['"])?(?![A-Za-zÀ-Úà-ú])/g).map(s => s.toLowerCase()).join('_');
    },
    getAction() {
      if (this.setting.id) {
        return request.update;
      }
      return request.create;
    },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.getAction()(this.setting).then(() => {
            this.clearData = true;
            this.$vs.notify({
              color: 'success',
              title: 'Sucesso!',
              text: 'Ação realizada com sucesso.'
            })
          })
          .catch((error) => {
            this.clearData = false;
            console.log(error);
          })
          .finally(() => {
            if (this.clearData) {
              this.errors.clear()
              this.$emit('closeSidebar');
              this.$emit('updateMessages');
            }
          })
        }
      });
    },
    insertTagOnText() {
      const that = this
      let tArea = this.$refs['quick-answer']

      let startPos = tArea.selectionStart
      let endPos = tArea.selectionEnd
      let cursorPos = startPos
      let tmpStr = tArea.value || ''

      that.setting.value = `${tmpStr.substring(0, startPos)}{{nome_contato}}` +
          `${tmpStr.substring(endPos, tmpStr.length)}`

      setTimeout(() => {
        cursorPos += that.setting.value.length
        tArea.selectionStart = tArea.selectionEnd = cursorPos
        that.$refs['quick-answer'].focus()
      }, 10)
    },
  },
  components: {
    VuePerfectScrollbar,
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}

@import "@/assets/scss/vuexy/extraComponents/tree.scss";


.height-auto {
  height: auto !important;
}

.message-text-area {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.tags-wrapper {
  background-color: #f8f8f8;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom-left-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
  border-top: none !important;

  > ul > li {
    display: inline-block;
  }
}

.text-area {
  margin-top: 10px;
  background: #fff;
  height: 200px;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  resize: none !important;
}

.align-right {
  float: right;
}
.message-preview {
  color: #fff;
  position: relative;
  display: inline-block;
  padding: 10px;
  background-color: #279dfb;
  border-radius: 10px;
}

.message-preview::before {
  content: "";
  position: absolute;
  top: 22.5%;
  right: -10px;
  transform: translateY(-40%);
  border-bottom: 23px solid transparent;
  border-left: 20px solid #279dfb;
  border-top: 0px solid transparent;
}

.message-preview p {
  margin-right: 0;
  
}
</style>